module.exports = __webpack_public_path__ + "static/media/big-login-right-wave.ad823b85.svg";